export default __webpack_public_path__ + "static/media/Machine Icon, Green.878daed1.png";